import { render } from "./RequestAbout.vue?vue&type=template&id=5caf9914&scoped=true&ts=true"
import script from "./RequestAbout.vue?vue&type=script&lang=ts"
export * from "./RequestAbout.vue?vue&type=script&lang=ts"

import "./RequestAbout.vue?vue&type=style&index=0&id=5caf9914&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caf9914"]])

export default __exports__